import React, { FC } from 'react'
import styles from './CountryFlagIcon.module.scss'
import { MODAL_NAME } from 'components/Preferences/Modal/Preferences'
import CountryFlagSvg from 'components/CountryFlag/CountryFlagSvg'
import classNames from 'classnames'
import useModal from 'hooks/useModal'
import { useSelector } from 'react-redux'
import { getUserPreferencesCountryCode } from 'selectors/user/cookie'

type CountryFlagIconProps = { customClassName?: string }

const CountryFlagIcon: FC<CountryFlagIconProps> = ({ customClassName = '' }) => {
  const userPreferencesCountryCode = useSelector(getUserPreferencesCountryCode)
  const { showModal } = useModal()

  return (
    <div
      title='View Store Preferences'
      className={classNames(styles.countryFlagBox, {
        [customClassName]: customClassName !== '',
      })}
      onClick={() => showModal(MODAL_NAME)}
      data-type='country-flag-icon'
    >
      <CountryFlagSvg
        country={userPreferencesCountryCode?.toLowerCase()}
        customClassName={customClassName}
      />
    </div>
  )
}

export default CountryFlagIcon
